import { render, staticRenderFns } from "./apply_account.vue?vue&type=template&id=8633c126&scoped=true"
import script from "./apply_account.vue?vue&type=script&lang=js"
export * from "./apply_account.vue?vue&type=script&lang=js"
import style0 from "./apply_account.vue?vue&type=style&index=0&id=8633c126&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8633c126",
  null
  
)

export default component.exports